import React, { useState, useEffect, useCallback } from 'react'
import { app, use, api } from 'xadmin'
import { Icon, C } from 'xadmin-ui'
import { Button, Select, Divider, Input, InputNumber, Radio, DatePicker, TimePicker, Checkbox, Modal, Card,
  Tag } from 'antd'
import _ from 'lodash'
import moment from 'moment'
import PointTable from './PointTable'

const { Option } = Select
const { RangePicker } = DatePicker

// 将schema.properties转换成数组形式
const convertProps = (properties, form) => {
  let ops = []
  let list = form && !(form.length == 1 && form[0] == '*') ? (form.includes('*') ? _.uniq([...(form.filter(item => item !== '*').map(item => item.key ?? item) || []), ..._.keys(properties)]) : form.map(f => f.key ?? f)) : _.keys(properties)  // 和表单显示顺序统一
  const parseProps = ( propertKeys, properties, prefix) => propertKeys.map(item => {
    if (item == 'id') return
    const prev = properties[item] || {}
    if (prev.relateTo || prev.relate) {
      prev.properties = {}
    }
    if (prev.properties && !_.isEmpty(prev.properties)) {
      prev.key = item
      parseProps(Object.keys(prev.properties), prev.properties, prev)
    } else {
      const title = prev.title ? prefix && prefix.title ? prefix.title + '-' + prev.title : prev.title : item
      ops.push({
        ...prev,
        title,
        key: prefix && prefix.key ? prefix.key + '.' + item : item,
      })
    }
  })
  parseProps(list, properties)
  // 过滤无名称属性
  return ops
}

// 时间格式化
const formatDate = (value, dateFormat) => {
  if (_.isPlainObject(value) && value['gte'] && value['lte']) {
    const format = dateFormat || 'YYYY-MM-DD HH:mm:ss'
    value = [moment(value['gte'], format), moment(value['lte'], format)]
  } else {
    value = null
  }
  return value
}

const TextInput = ({ input }) => {
  return <Input style={{ width: '100%' }} {...input} />
}
const NumberInput = ({ input }) => {
  return <InputNumber style={{ width: '100%' }} {...input} value={_.isNil(input.value) ? input.value : Number(input.value)}/>
}
const BooleanInput = ({ input }) => {
  return <Radio.Group
    options={[{ label: '真', value: true }, { label: '假', value: false }]}
    onChange={input.onChange}
    value={input.value}
    optionType="button"
    buttonStyle="solid"
  />
}
const EnumInput = ({ input, field: { schema = {} } }) => {
  const enum_title = schema.enum_title || []
  const enums = schema.enum || []
  return <Select value={input.value} onChange={input.onChange} style={{ width: '100%' }}>
    {
      enums?.map((item, index) => {
        return <Option value={item}>{enum_title[index] || item}</Option>
      })
    }
  </Select>
}
const RangeInput = ({ input }) => {
  const onChange = (val, t) => {
    input.onChange({ ...input.value, [t]: val })
  }
  return <div style={{ display: 'flex' }}>
    <InputNumber value={input.value?.gte} onChange={v => onChange(v, 'gte')} style={{ flexGrow: 1, width: '100%' }}></InputNumber>
    <span style={{ margin: 'auto 5px' }}>~</span>
    <InputNumber value={input.value?.lte} onChange={v => onChange(v, 'lte')} style={{ flexGrow: 1, width: '100%' }}></InputNumber>
  </div>
}
const RangeTimeInput = ({ input, field: { schema } }) => {
  const format = schema?.format || schema?.formatType
  const timeFormat = schema?.timeFormat || (format == 'time' ? 'HH:mm:ss' : format == 'date' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss')
  const onChange = (val) => {
    const date = val ? { 'gte': moment(val[0]).format(timeFormat), 'lte': moment(val[1]).format(timeFormat) } : val
    input.onChange(date)
  }
  return format == 'time' || schema?.timeFormat ? <TimePicker.RangePicker onChange={onChange} value={formatDate(input.value, timeFormat)} format={timeFormat} style={{ width: '100%' }} /> :
    <RangePicker showTime={format !== 'date'} onChange={onChange} value={formatDate(input.value, timeFormat)} style={{ width: '100%' }} />
}
const VariateRangeTimeInput = ({ input: { value, onChange }, field: { schema } }) => {
  const format = schema?.format || schema?.formatType
  const timeFormat = schema?.timeFormat || (format == 'time' ? 'HH:mm:ss' : format == 'date' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss')
  const [type, setType] = useState(value?.type)
  const opts = [ { key: '前', value: 'forward' }, { key: '后', value: 'backward' }, { key: '当前', value: 'now' } ]
  const list = [ { key: '年', value: 'Y' }, { key: '季度', value: 'Q' }, { key: '月', value: 'M' }, { key: '周', value: 'w' }, { key: '天', value: 'd' }, { key: '时', value: 'h' }, { key: '分', value: 'm' }, { key: '秒', value: 's' } ]
  const unitList = list.filter(item => {
    const arr = timeFormat == 'YYYY-MM-DD' ? ['Y', 'Q', 'M', 'w', 'd'] : timeFormat == 'HH:mm:ss' ? ['h', 'm', 's'] : timeFormat == 'HH:mm' ? ['h', 'm'] : list.map(v => v.value)
    return arr.indexOf(item.value) > -1
  })
  const handleChange = v => {
    const timeRange = { ...value, ...v }
    const start = timeRange.fromNow ? 'now' : 'nowzero'
    const mid = timeRange.type == 'forward' ? ' - ' : timeRange.type == 'backward' ? ' + ' : ''
    const end = timeRange.unit && !_.isNil(timeRange.count) ? timeRange.count + timeRange.unit : ''
    const newTime = timeRange.unit ? (timeRange.type == 'now' ? 'now ' + timeRange.unit : (end && mid ? start + mid + end : null)) : null
    onChange(timeRange, newTime)
  }
  return (
    <>
      <div style={{ display: 'flex', marginBottom: '0.5rem' }}>
        <Select style={{ marginRight: 5, minWidth: '30%' }} value={value?.type} onChange={v => {setType(v);handleChange({type: v})}} allowClear >
          {opts.map(item => <Select.Option value={item.value}>{item.key}</Select.Option>)}
        </Select>
        {type != 'now' && <InputNumber value={value?.count} onChange={(v) => handleChange({count: v})} placeholder="输入数值" min={1} style={{ flexGrow: 1, marginRight: 5, minWidth: '30%' }} />}
        <Select allowClear value={value?.unit} onChange={v => handleChange({unit: v})} style={{ minWidth: '30%' }}>
          {unitList.map(item => <Select.Option value={item.value}>{item.key}</Select.Option>)}
        </Select>
      </div>
      {type != 'now' && <div style={{ marginBottom: '0.5rem' }}><Checkbox checked={value?.fromNow} onChange={e => handleChange({fromNow: e.target.checked})}>从当前开始</Checkbox></div>}
    </>
  )
}
const TimeInput = ({ input, field: { schema } }) => {
  const format = schema?.format || schema?.formatType
  const timeFormat = schema?.timeFormat || (format == 'time' ? 'HH:mm:ss' : format == 'date' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss')
  const onChange = (val) => {
    input.onChange(val ? moment(val).format(timeFormat) : val)
  }
  return format == 'time' || schema?.timeFormat ?
    <TimePicker onChange={onChange} value={input.value && typeof input.value == 'string' ? moment(input.value, timeFormat) : null} format={timeFormat} style={{ width: '100%' }} /> :
    <DatePicker showTime={format !== 'date'} onChange={onChange}
      value={input.value && typeof input.value == 'string' ? moment(input.value, timeFormat) : null} style={{ width: '100%' }} />
}
const PointDataSelect = props => {
  const { input: { value, onChange }, field: { schema }, pointType } = props
  const [ data, setData ] = useState({ visible: false, data: [] })
  return (
    <>
      <div style={{ display: 'flex', marginBottom: '0.5rem' }}>
        <Button onClick={ () => setData({ ...data, visible: true }) }>数据点</Button>
        <Modal visible={data.visible} width='80%' onCancel={()=> setData({ ...data, visible: false })} onOk={()=> setData({ ...data, visible: false })}>
          { pointType == 'model' ? <C is="ModelPointTable" {...props} type="radio" fullLable={true} noComputed={true} /> : null }
          { pointType == 'node' ? <PointTable {...props} type="radio" noComputed={true} /> : null }
        </Modal>
      </div>
      {
        value ? <Card bodyStyle={{ width: '100%', borderRadius: '5px', padding: 5 }}>
       
            <Tag closable onClose={(e) => { onChange(null) }}>{
              (value?.model?.name || value?.node?.name) + '-' + value.name || value.name
            }</Tag>
        </Card> : null
      }
    </>
  )
}
const NullInput = () => null

const METHODS = {
  'string': [
    { name: '是', key: 'eq', component: TextInput },
    { name: '不是', key: 'ne', component: TextInput },
    { name: '包含', key: 'contains', component: TextInput },
    { name: '不包含', key: 'notContains', component: TextInput },
    { name: '开始为', key: 'startsWith', component: TextInput },
    { name: '结尾为', key: 'endsWith', component: TextInput },
    { name: '为空', key: 'isNull', component: NullInput },
    { name: '不为空', key: 'notNull', component: NullInput },
  ],
  'number': [
    { name: '等于', key: 'eq', component: NumberInput },
    { name: '不等于', key: 'ne', component: NumberInput },
    { name: '大于', key: 'gt', component: NumberInput },
    { name: '小于', key: 'lt', component: NumberInput },
    { name: '大于等于', key: 'gte', component: NumberInput },
    { name: '小于等于', key: 'lte', component: NumberInput },
    { name: '在范围内', key: 'range', component: RangeInput },
    { name: '不在范围内', key: 'notRange', component: RangeInput },
    { name: '为空', key: 'isNull', component: NullInput },
    { name: '不为空', key: 'notNull', component: NullInput },
  ],
  'boolean': [
    { name: '等于', key: 'eq', component: BooleanInput },
    { name: '为空', key: 'isNull', component: NullInput },
    { name: '不为空', key: 'notNull', component: NullInput },
  ],
  'date': [
    { name: '等于', key: 'eq', component: TimeInput },
    { name: '早于', key: 'lt', component: TimeInput },
    { name: '晚于', key: 'gt', component: TimeInput },
    { name: '为空', key: 'isNull', component: NullInput },
    { name: '不为空', key: 'notNull', component: NullInput },
    { name: '在范围内', key: 'range', component: RangeTimeInput },
    { name: '不在范围内', key: 'notRange', component: RangeTimeInput },
  ],
  'enum': [
    { name: '等于', key: 'eq', component: EnumInput },
    { name: '不等于', key: 'ne', component: EnumInput },
    { name: '包含', key: 'include' },
    { name: '不包含', key: 'notInclude' },
    { name: '为空', key: 'isNull', component: NullInput },
    { name: '不为空', key: 'notNull', component: NullInput },
  ],
  'relate': [
    { name: '包含', key: 'in' },
    { name: '不包含', key: 'nin' },
    { name: '为空', key: 'isNull', component: NullInput },
    { name: '不为空', key: 'notNull', component: NullInput },
  ],
  'relateTo': [
    { name: '等于', key: 'eq' },
    { name: '不等于', key: 'ne' },
    { name: '包含', key: 'include' },
    { name: '不包含', key: 'notInclude' },
    { name: '为空', key: 'isNull', component: NullInput },
    { name: '不为空', key: 'notNull', component: NullInput },
  ],
  'other': [
    { name: '为空', key: 'isNull', component: NullInput },
    { name: '不为空', key: 'notNull', component: NullInput },
  ]
}

const QueryItemFrom = ({ value, schema, field, onChange, unbind, timeRangeQuery }) => {
  const [methods, setMethods] = useState()
  const [isTime, setIsTime] = useState()
  const [ isPointData, setIsPointData ] = useState()
  const [fieldCovert, setFieldCovert] = useState({ schema: schema.properties[field] || {} })
  const filters = schema.filters ? _.map(schema.filters, val => val)?.reduce( (a, b) => a.concat(b) ) : []
  const filterSchema = filters.filter(v => v.key == field)[0]
  const f = field.replace('.', '.properties.')
  const fieldSchema = _.omit(_.get(schema.properties, f), 'filterByRes') || {}
  const properties = convertProps(schema.properties)
  const ops = properties.filter(item => item.key != 'model' && item.key != 'dashboard')

  React.useEffect(() => {
    const prop = _.find(ops, v => (v.key || v.id) == field)
    if (prop) {
      if(fieldSchema?.key == 'dataPoint') {
        setMethods(METHODS['string'].filter(m => ['contains', 'notContains'].indexOf(m.key) > -1))
        setIsPointData(true)
      } else if (fieldSchema.selectType == 'multiple') {
        const ms = fieldSchema.relateTo ? [ { name: '包含', key: 'include' }, { name: '不包含', key: 'notInclude' }, ...METHODS['other'] ] : METHODS['other']
        setMethods(ms)
      } else if (filterSchema && prop.fieldType != 'parentnode') {
        setMethods(METHODS['relate'])
      } else if (fieldSchema.relateTo || fieldSchema.relate) {
        setMethods(METHODS[fieldSchema.relate ? 'relate' : 'relateTo'])
      } else if (prop.type == 'object' && fieldSchema.fieldType && fieldSchema.fieldType != 'attachment' && fieldSchema.fieldType != 'map') {
        setMethods(METHODS['relateTo'])
      } else if (prop.type == 'array' && ((fieldSchema.fieldType && ['attachments', 'parentnode'].indexOf(fieldSchema.fieldType) === -1) || fieldSchema.component)) {
        setMethods(METHODS['relate'])
      } else if (fieldSchema.fieldType === 'area') { // 区域
        setMethods(METHODS['enum'].filter(m => m.key != 'include' && m.key != 'notInclude'))
      } else if (fieldSchema.fieldType === 'textEditor') { // 富文本
        setMethods(METHODS['string'].filter(m => ['contains', 'notContains', 'isNull', 'notNull'].indexOf(m.key) > -1))
      } else {
        const format = ['date', 'datetime', 'date-time', 'time']
        if (format.includes(prop.format) || prop.timeFormat || prop.fieldType == 'datePicker' || prop.fieldType == 'timePicker') {
          setMethods(METHODS['date'])
          if (['date', 'datetime', 'date-time'].includes(prop.format) || prop.fieldType == 'datePicker') setIsTime(true)
        } else {
          setMethods(METHODS[prop.enum || prop.enum1 ? 'enum' : prop.type] || METHODS['other'])
        }
      }
    } else {
      setMethods([])
    }
  }, [schema, field])

  const onMethodChange = key => {
    onChange({ ..._.omit(value, 'timeRange'), method: key, value: null })
  }

  const onValueChange = v => {
    onChange({ ...value, value: v?.target ? v.target.value : v })
  }
  const onTimeRangeChange = (timeRange, v) => {
    onChange({ ...value, timeRange, value: v })
  }
  const onPointRangeChange = (pointRange) => {
    onChange({ ...value, pointRange: { ...value?.pointRange, data: pointRange }, value: { ...value?.pointRange, data: pointRange  } })
  }

  const selectMethod = value?.method

  const convert = (schema, options) => {
    const opts = options || {}
    return app.load_list('filter_converter').reduce((prve, converter) => {
      return converter(prve, schema, opts)
    }, {})
  }

  const convert1 = (schema, options) => {
    const opts = options || {}
    if (opts.path === undefined) {
      opts.path = []
    }
    if (opts.lookup === undefined) {
      opts.lookup = {}
    }
    return app.get('schema_converter').reduce((prve, converter) => {
      return converter(prve, schema, opts)
    }, opts.global && opts.global?.formDefaults ? _.cloneDeep(opts.global.formDefaults) : {})
  }

  const getConvertCom = (fSchema, method) => {
    if (!fSchema.fieldType && !fSchema.relateTo && !fSchema.relate && !fSchema.enum && !fSchema.enum1) return
    let convertSchema
    if (method?.key == 'include' || method?.key == 'notInclude') {
      convertSchema = convert1({ items: { type: fSchema.type, properties: {}, relateTo: fSchema.relateTo }, ...fSchema, selectType: 'multiple', type: 'array' })
      if (convertSchema.type == 'array') convertSchema = convert(fSchema)
    } else {
      convertSchema = convert(fSchema)
    }
    setFieldCovert({...fSchema, ...convertSchema})
    const type = convertSchema.type
    const formFields = app.get('form_fields')
    return formFields[type]?.component
  }

  const ValueComponent = React.useMemo(() => {
    if (!methods) return NullInput
    const method = _.find(methods, m => m.key == selectMethod) || (methods && methods[0])
    if (fieldSchema?.selectFace) fieldSchema.selectFace = 'select'
    const fSchema = {...filterSchema, ...fieldSchema}
    setFieldCovert({ schema: fSchema })
    if (method?.key == 'isNull' || method?.key == 'notNull') {
      return method?.component
    }
    if (fSchema.fieldType && (fSchema.enum || fSchema.enum1) || fSchema.relateTo || fSchema.fieldType === 'area') {
      return fSchema.component || getConvertCom(fSchema, method) || TextInput
    }
    return fSchema.component || method?.component || getConvertCom(fSchema, method) || TextInput
  }, [methods, selectMethod])

  const [rangeType, setRangeType] = useState(value?.timeRange?.rangeType)
  const [pointType, setPointType] = useState(value?.pointRange?.pointType || 'model')

  return (
    <>
      <div style={{ width: '100%', marginBottom: '0.5rem' }}>
        {
          isPointData ? <Radio.Group optionType="button" defaultValue='model' onChange={v => { setPointType(v.target.value); 
            onChange({ ...value, pointRange: { ...value?.pointRange, pointType: v.target.value } })}} value={pointType}>
            <Radio value={'model'}>模型</Radio>
            <Radio value={'node'}>资产</Radio>
          </Radio.Group> : null
        }
      </div>
      <div style={{ width: '100%', display: 'flex', flexDirection: 'row', marginBottom: '0.5rem' }}>
        <Select
          value={selectMethod}
          placeholder="请选择"
          style={{ marginRight: '0.5rem', width: 100 }}
          onChange={onMethodChange}
        >
          {(methods || []).map(m => {
            return <Option value={m.key}>{m.name}</Option>
          })}
        </Select>
        <div style={{ flexGrow: 1 }}>
          {
            (selectMethod == 'range' || selectMethod == 'notRange') && timeRangeQuery && isTime ? 
            <Select defaultValue='fixed' value={rangeType} onChange={v => {setRangeType(v); onChange({ ...value, timeRange: { rangeType: v } })}}>
              <Select.Option value='fixed'>固定范围</Select.Option>
              <Select.Option value='dynamic'>变化范围</Select.Option>
            </Select> : isPointData ? 
            <PointDataSelect pointType={pointType} {...fieldSchema} input={{ value: value?.pointRange?.data, onChange: onPointRangeChange }} field={fieldCovert} label={fieldSchema.title}/>
            : <C is="DashboardDataWrap" input={{ value: value?.value, onChange: onValueChange }} field={{...fieldSchema, unbind: unbind}} bind={!unbind}>
              <ValueComponent {...fieldSchema} input={{ value: value?.value, onChange: onValueChange }} field={fieldCovert} label={fieldSchema.title} meta={{}} />
            </C>
          }
        </div>
      </div>
      {
        (selectMethod == 'range' || selectMethod == 'notRange') && timeRangeQuery && isTime &&
        (rangeType == 'dynamic' ? <VariateRangeTimeInput {...fieldSchema} input={{ value: value?.timeRange, onChange: onTimeRangeChange }} field={fieldCovert} label={fieldSchema.title}></VariateRangeTimeInput> :
          <div style={{ marginBottom: '0.5rem' }}>
            <C is="DashboardDataWrap" input={{ value: value?.value, onChange: onValueChange }} field={{...fieldSchema, unbind: unbind}} bind={!unbind} >
              <ValueComponent {...fieldSchema} input={{ value: value?.value, onChange: onValueChange }} field={fieldCovert} label={fieldSchema.title} meta={{}} />
            </C>
          </div>)
      }
    </>
  )
}

const QueryFieldSelect = ({ schema, value, onChange, getSchema }) => {

  const properties = convertProps(schema.properties, schema.form)
  //报警需要model
  const ops = properties.filter(item => item.key != 'model' && item.key != 'dashboard' && item.fieldType !== 'editableTable')

  const getType = (item) => {
    // 工作表显示字段类型，不显示数据类型
    if (item.config) return item.config
    switch (item.type) {
      case 'string':
        return '字符串'
      case 'number':
        return '数字'
      case 'integer':
        return '整数'
      case 'boolean':
        return '布尔'
      case 'object':
        return '对象'
      case 'array':
        return '数组'
      default:
        return '字符串'
    }
  }

  const handleDropdown = state => {
    if (state && getSchema) { // 每次下拉动态获取 schema
      getSchema()
    }
  }

  return (
    <Select
      showSearch
      value={value}
      style={{ marginRight: '0.5rem', flexGrow: 1 }}
      placeholder="选择过滤字段"
      optionFilterProp="children"
      onChange={onChange}
      onDropdownVisibleChange={handleDropdown}
    // filterOption={(input, option) =>
    //   option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
    // }
    >
      {ops.map(item => {
        const key = item.key || item.id
        const title = item.title || item.name
        if (!key || !title) return null
        return <Option value={key} key={key}><span style={{ color: '#999' }}>[{getType(item)}]</span> {title}</Option>
      })}
    </Select>
  )
}

const QueryItem = ({ value, schema, onChange, onDelete, unbind, getNewSchema, timeRangeQuery }) => {
  const [newSchema, setNewSchema] = React.useState(schema)

  const getSchema = () => {
    getNewSchema && getNewSchema().then(schema1 => {
      setNewSchema(schema1)
    }).catch(e => console.error(e))
  }

  return (
    <>
      <div style={{ width: '100%', display: 'flex', flexDirection: 'row', marginBottom: '0.5rem' }}>
        <QueryFieldSelect schema={newSchema} value={value?.field} onChange={field => onChange({ field })} getSchema={getSchema} />
        <div style={{ margin: 'auto' }}>
          <Icon svg={require('../icon/垃圾桶.svg')} className="array-delete" onClick={onDelete} />
        </div>
      </div>
      {value?.field ? <QueryItemFrom schema={newSchema} field={value?.field} value={value} onChange={onChange} unbind={unbind} timeRangeQuery={timeRangeQuery} /> : null}
    </>
  )
}

const QueryForm = ({ query, schema, onChange, relation, unbind, getNewSchema, timeRangeQuery }) => { 
  let error = {}
  query?.forEach(item => {
    if (item?.field && query.filter(q => q?.field == item.field)?.length > 1) {
      error = { ...error, [item.field]: '且逻辑中不能存在重复字段' }
    }
  })
  const onItemChange = (i) => value => {  
    const f = value.field.replace('.', '.properties.')
    if (_.get(schema.properties, f)?.type == 'boolean') {
      if (_.isNil(value?.value)) {
        value['value'] = true
      }
    }
    onChange([
      ...query.slice(0, i),
      value,
      ...query.slice(i + 1)
    ])
  }

  const onItemDelete = (i) => () => {
    onChange([
      ...query.slice(0, i),
      ...query.slice(i + 1)
    ])
  }

  const onAddQuery = () => {
    onChange([...query, {}])
  }

  return query.map((item, i) => {
    const errorIndex = error[item.field] ? query.findLastIndex(q => q?.field == item.field) : -1
    return (
      <span key={item.field + item.method}>
        <QueryItem onChange={onItemChange(i)} onDelete={onItemDelete(i)} value={item} schema={schema} fieldProp={{}} unbind={unbind} getNewSchema={getNewSchema} timeRangeQuery={timeRangeQuery} />
        {errorIndex == i && <div style={{ fontSize: 12, color: '#ff4d4f' }}>{error[item.field]}</div>}
        {!relation || relation == 'and' ?
          i == query.length - 1 ? <Button onClick={onAddQuery}>+ 且</Button> : <div style={{ margin: '0 1rem 0.5rem 1rem' }}>且</div> : null}
      </span>
    )
  })
}

/**
  * @param {string} relation 逻辑关系
  * @param {boolean} unbind 不能绑定数据 
  * @param {boolean} timeRangeQuery 是否用于查询-用于查询的时间字段可以定义变化范围
*/ 

const QueryEditor = props => {
  const { schema, input, relation, unbind, getNewSchema, style, timeRangeQuery } = props
  const { value = [], onChange } = input
  const [queries, setQueries] = useState(value)

  const saveQueries = queries => {
    const qs = queries.filter(q => !_.isEmpty(q))
    setQueries(qs)
    onChange && onChange(qs)
  }

  React.useEffect(() => {
    setQueries(input.value)
  }, [input.value])

  const addQuery = useCallback((i, fieldName) => {
    const query = queries[i] || []
    const newQuery = [
      ...query,
      { field: fieldName }
    ]
    saveQueries([..._.set(queries, i, newQuery)])
  }, [queries])

  const onAddOrQuery = useCallback(() => {
    saveQueries([
      ...queries,
      [{}]
    ])
  }, [queries])

  const setQuery = i => query => {
    if (_.isEmpty(query)) {
      saveQueries([...queries.slice(0, i), ...queries.slice(i + 1)])
    } else {
      saveQueries([..._.set(queries, i, query)])
    }
  }

  if (_.isEmpty(queries)) {
    return <Button onClick={() => addQuery(0)}>添加过滤条件</Button>
  } else {
    return queries.map((query, i) => {
      return (
        <div style={style}>
          <QueryForm query={query} schema={schema} onChange={setQuery(i)} relation={relation} unbind={unbind} getNewSchema={getNewSchema} timeRangeQuery={timeRangeQuery} />
          {!relation || relation == 'or' ?
            i == queries.length - 1 ? <Button style={{ marginLeft: '0.5rem' }} onClick={onAddOrQuery}>+ 或</Button> : <Divider plain>或</Divider> :
            null
          }
        </div>
      )
    })
  }
}

export default QueryEditor
